import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=626d8788&scoped=true"
import script from "./phoneNumber.vue?vue&type=script&lang=ts"
export * from "./phoneNumber.vue?vue&type=script&lang=ts"
import style0 from "./phoneNumber.vue?vue&type=style&index=0&id=626d8788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d8788",
  null
  
)

export default component.exports